/**
 * DOM
 */
jQuery(document).ready(function ($) {

   function initSliders() {

      // Évite la double initialisation
      if ($('.bx-wrapper').length > 0) return;

      // ── slider principal ──────────────────────────────────────
      $('.slider').each(function () {
         var ul    = $(this);
         var count = ul.children().length;
         if (count > 1) {
            ul.bxSlider({
               nextText:  '<i class="fa-light fa-arrow-right-to-line"></i>',
               prevText:  '<i class="fa-light fa-arrow-left-to-line"></i>',
               pager:     false,
               auto:      true,
               pause:     4000,
               autoHover: true
            });
         }
      });

      // ── slider logos ──────────────────────────────────────────
      $('.sliderLogo').each(function () {
         var w         = $(window).width();
         var r_largeur = w < 550 ? 1 : w < 750 ? 3 : 5;
         var ul        = $(this);
         var count     = ul.children().length;
         if (count > 1) {
            ul.bxSlider({
               controls:   false,
               pager:      false,
               auto:       true,
               pause:      4000,
               autoHover:  false,
               minSlides:  r_largeur,
               maxSlides:  r_largeur,
               moveSlides: 1,
               speed:      1500,
               slideWidth: 3000,
            });
         }
      });

      // ── citations ─────────────────────────────────────────────
      $('.carouselCitations').each(function () {
         var ul    = $(this);
         var count = ul.children().length;
         if (count > 1) {
            ul.bxSlider({
               mode:       'horizontal',
               startSlide: 0,
               speed:      1000,
               controls:   false,
               pager:      true,
               auto:       true,
               pause:      5000,
            });
         }
      });

      // ── étapes ────────────────────────────────────────────────
      $('.slider_etapes').each(function () {
         var ul    = $(this);
         var count = ul.children().length;
         if (count > 1) {
            ul.bxSlider({
               mode:         'horizontal',
               startSlide:   0,
               speed:        1000,
               controls:     false,
               infiniteLoop: false,
               pager:        true,
               auto:         false,
               pause:        5000,
            });
         }
      });

      // ── photos ────────────────────────────────────────────────
      $('.sliderPhotos').each(function () {
         var ul    = $(this);
         var count = ul.children().length;
         if (count > 1) {
            ul.bxSlider({
               mode:         'horizontal',
               startSlide:   0,
               speed:        1000,
               controls:     false,
               infiniteLoop: false,
               pager:        true,
               auto:         true,
               pause:        15000,
            });
         }
      });

   } // fin initSliders()

   // 1re tentative dès que le DOM est prêt
   initSliders();

   // Filet de sécurité après chargement complet des ressources
   $(window).on('load', function () {
      if ($('.bx-wrapper').length === 0) {
         initSliders();
      }
   });

});